// @ts-nocheck
/**
 * CSRD API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * The Parameter determinationType
 */
export type DeterminationType = 'Measured' | 'Calculated' | 'Estimated';

export const DeterminationType = {
    Measured: 'Measured' as DeterminationType,
    Calculated: 'Calculated' as DeterminationType,
    Estimated: 'Estimated' as DeterminationType
};

